<template>
  <div class="leads-filtering">
    <div class="leads-filtering--sync-status">
      <div v-if="$store.getters.getOrganizationConfig('crm_presence')" class="leads-filter">
        <div class="label">{{$t('ui.filters.sync_status')}}</div>
        <field type="checkbox"
          v-if="newFilters.sync_status"
          name="sync_status"
          label=" "
          model="leads"
          class="is-inline"
          v-model="newFilters.sync_status.value"
          :collection="syncStatusCollection"
        ></field>
      </div>
      <div class="leads-filter">
        <div class="label">{{$t('ui.filters.origin')}}</div>
        <field type="checkbox"
          v-if="newFilters.origin"
          name="origin"
          label=" "
          model="leads"
          class="is-inline"
          v-model="newFilters.origin.value"
          :collection="originCollection"
        ></field>
      </div>
      <div class="leads-filter">
        <div class="label">{{$t('ui.filters.import_origin')}}</div>
        <field type="checkbox"
          v-if="newFilters.import_origin"
          name="importOrigin"
          label=" "
          model="leads"
          class="is-inline"
          v-model="newFilters.import_origin.value"
          :collection="importOriginCollection"
        ></field>
      </div>
      <div class="leads-filter" v-if="$store.getters.getOrganizationConfig('crm_presence')">
        <div class="label">{{$t('ui.filters.sync_disabled')}}</div>
        <field type="checkbox"
          v-if="newFilters.sync_disabled"
          name="sync_disabled"
          label=" "
          model="leads"
          class="is-inline"
          v-model="newFilters.sync_disabled.value"
          :collection="syncDisabledCollection"
        ></field>
      </div>
      <div class="leads-filter">
        <div class="label">{{$t('ui.filters.start_date')}}</div>
        <div class="field grid has-gutter-xl">
          <datepicker
            v-if="newFilters.start_date"
            :clear-button="true"
            v-model="newFilters.start_date.start"
            input-class="input--datepicker"
            id="start_date"
            name="start_date"
            :language="getDatePickerLanguage()"
          />
          <datepicker
            v-if="newFilters.start_date"
            :clear-button="true"
            v-model="newFilters.start_date.end"
            input-class="input--datepicker"
            id="end_date"
            name="end_date"
            :language="getDatePickerLanguage()"
          />
        </div>
      </div>
      <div class="leads-filter--validate">
        <a @click="reset">
        <button class="btn btn-tertiary">{{$t('ui.filters.reset')}}</button>
        </a>
        <a  @click="apply">
        <button class="btn btn-primary btn-save">{{$t('ui.filters.apply')}}</button>
        </a>

      </div>
    </div>
  </div>
</template>
<script>
import Field from '@/components/helpers/DataInput/Field'
import Datepicker from "vuejs-datepicker"

export default {
  components: {
    Field,
    Datepicker
  },
  data(){
    return{
      newFilters: {},
      syncStatusCollection: [{value: 'not_synced'},{value: 'not_sync_ready'},{value: 'sync_ready'},{value: 'sync_error'},{value: 'synced'},{value: 'no_crm'}],
      originCollection: [{value: "web_app"}, {value: "mobile_app"}, {value: "external_form"}],
      syncDisabledCollection: [{value: "true"}, {value: "false"} ],
      importOriginCollection: [{value: "xls"}, {value: "crm"}]
    }
  },
  props: ['filters'],
  beforeMount(){
    this.init()
  },
  methods: {
    init(){
      if(!_.isEmpty(this.filters.filters)){
        this.newFilters = this.filters.filters
      }else{
        this.newFilters = {sync_status: {value: []}, sync_disabled: {value: []}, origin: {value: []}, import_origin: {value: []}, start_date: {start: null, end: null, type: 'date'}}
      }

      if(!this.newFilters.sync_status){
        this.newFilters.sync_status.value = []
      }
      if(!this.newFilters.origin){
        this.newFilters.origin.value = []
      }
      if(!this.newFilters.import_origin){
        this.newFilters.import_origin.value = []
      }
      if(!this.newFilters.sync_disabled){
        this.newFilters.sync_disabled.value = []
      }
      if(!this.newFilters.start_date){
        this.newFilters.start_date = {}
        this.newFilters.start_date.start = null
        this.newFilters.start_date.end = null
        this.newFilters.start_date.type = 'date'
      }
      if(!this.newFilters.tags) {
        this.newFilters.tags       = {}
        this.newFilters.tags.value = []
        this.newFilters.tags.type  = 'tag'
      }
    },
    reset(){
      this.$emit('reset', this.newFilters)
    },
    apply(){
      this.$emit('apply', this.newFilters)
    }
  },
  watch: {
    filters:{
      deep: true,
      handler(){
        this.newFilters = this.filters.filters
      }
    }
  }
}
</script>
<style lang="less">
.leads-filtering{
  padding: 16px;
  background: #f9f9f9;
  margin-bottom: 16px;
  border-radius: 2px;
  input {
    max-width: 250px;
  }
  .leads-filter{
    display: flex;
    margin-bottom: 12px;
    .label{
      flex-grow: 4;
      margin-top: 1.2rem;
      width: 15%;
      font-size: 1em;
      @media(max-width: 576px) {
        margin-bottom: 20px;
      }
    }
    .field{
      flex-grow: 6;
      width: 85%;
      &>label{
        display: none;
      }
    }

  }
  .field.is-inline .field--radio, .field.is-inline .field--checkbox{
    height: auto;
    margin-right: 0.5em;
    margin-bottom: 0;
  }
  .input--checkbox + label{
    font-size: 1em;
    padding-left: calc(0.8rem * 2.2)
  }
  .input--checkbox + label:before, .input--checkbox + label:after{
    margin-top: 0.2em;
    width: 1rem;
    height: 1rem;
  }
  // .input--datepicker{
  //   font-size: 1.1em;
  //   font-weight: 200;
  //   padding-left: 2em;
  // }

  .vdp-datepicker {
    max-width: 250px;
    // &:before {
    //   right: -27px;
    // }
  }
  // .vdp-datepicker__clear-button{
  //   position: absolute;
  //   left: 0;
  //   top: 8px;
  //   font-size: 1.5em;
  //   color: #8BABCA;
  //   i{
  //     font-style: normal;
  //   }
  // }

  .leads-filter--validate{
    margin-top: -12px;
    text-align: right;
    .btn {
      font-weight: 400;
    }
    .btn-tertiary {
      border: 1px solid #E8E9EA;
    }
  }

  @media only screen and (max-width: 576px) {
    .leads-filter--validate{
      display: flex;
      justify-content: flex-start;
      margin-top: 10px;
    }
    .leads-filter {
      flex-direction: column;
    }
    .leads-filter .label {
      width: 100% !important;
    }
    .btn-tertiary {
      margin-right: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// LeadsFiltering.vue?7096a9d6